import React from "react";
import { Box, Typography, Button, Divider } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ROUTE_EDUCATION_NEW } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const styles = {
  root: {
    backgroundColor: "#FE845A",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    color: "#ffffff",
    fontFamily: "'Poppins', sans-serif",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  logo: {
    width: "109px",
    height: "58px",
    marginBottom: "20px",
    top: "10px",
    position: "absolute",
  },
  image: {
    borderRadius: "50%",
    width: "101px",
    height: "101px",
    marginBottom: "20px",
    marginTop: "20px",
  },
  section: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "5px",
  },
  subText: {
    fontSize: "14px",
    fontWeight: "600",
    textAlign: "center",
  },
  button: {
    padding: "15px 50px",
    color: "#756DE9",
    backgroundColor: "#ffffff",
    borderRadius: "99px",
    fontSize: "16px",
    fontWeight: "600",
    textTransform: "capitalize",
    width: "100%",
    marginTop: "20px",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },
  profileConsist: {
    marginBottom: "20px", // Add margin to create gap between line and first point
  },
};

const ProfileConsist = () => {
  const navigate = useNavigate();
  return (
    <Box sx={styles.root}>
      <img
        src="images/Seevi-Logo-White.png"
        alt=""
        style={{ width: "109px", height: "58px", marginBottom: "20px", top: "10px", position: "absolute" }}
      />

      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/9a279926f5968dd284eadea876740cae4d9b2d5f151b00029f0d8a7926ba9262?apiKey=d94ace7eb9234970be6d52e95c888888&"
        alt=""
        style={styles.image}
      />

      <Typography variant="h6" sx={{ ...styles.subText, ...styles.profileConsist }}>
        Profile consists of 4 items
      </Typography>

      <Stack direction="column" alignItems="center" sx={{ marginBottom: "40px" }}>
        {[1, 2, 3, 4].map((item, index) => (
          <React.Fragment key={item}>
            <Stack direction="column" alignItems="center" sx={{ mt: index !== 0 ? 1 : 0 }}>
              <Typography variant="h6" sx={styles.section}>
                {item === 1
                  ? "Education & Work Ex."
                  : item === 2
                  ? "Specialization"
                  : item === 3
                  ? "Video"
                  : "Personality"}
              </Typography>
              <Typography sx={styles.subText}>
                {item === 1
                  ? "Tell us about your education and experiences"
                  : item === 2
                  ? "Skill set, tools known and any certification courses you might have done"
                  : item === 3
                  ? "Flaunt your full personality and achievements in a video"
                  : "This will help us match with a perfect culturally fit org"}
              </Typography>
            </Stack>
            {index !== 3 && <Divider sx={{ backgroundColor: "#ffffff", mt: 2, mb: 2, width: "100%" }} />}
          </React.Fragment>
        ))}
      </Stack>

      <Button onClick={() => navigate(ROUTE_EDUCATION_NEW)} sx={styles.button} variant="contained" size="small">
        Got It
      </Button>
    </Box>
  );
};

export default ProfileConsist;
